import { BaseI18nManager } from "../../../../i18n";

type Section = { [key: string]: string; };

export type Labels = {

    menu: string;
    shop: string;
    my_teams: string;
    view_all: string;
    read_more: string;
    home: Section;
    match: Section;
    store: Section;
    schedule: Section;
    members: Section;
    news: Section;
    gallery: Section;
    activities: Section;
    achievements: Section;
    footer: Section;

}

export const i18nManager = new BaseI18nManager<Labels>({
    en_UK: require("./en_UK.json"),
});
